/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartCorellationMatrix = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M4 12v8h8v2H2V12zm13.985 4.57 1.508 1.508-1.414 1.415-1.508-1.508zm-3.016-3.015 1.508 1.508-1.414 1.414-1.508-1.508zm-3.016-3.016 1.508 1.508-1.414 1.414-1.508-1.508zM22 2v10h-2V4h-8V2zM8.938 7.524l1.508 1.508-1.414 1.414-1.508-1.508zM5.922 4.508 7.43 6.016 6.016 7.43 4.508 5.922z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgChartCorellationMatrix as ChartCorellationMatrix };
